var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_vm._v("当前量表二维码已过期，请联系管理员")])
}
var staticRenderFns = []

export { render, staticRenderFns }